import React, { useEffect, useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfVideo from '@elem/ui/ef-video';
import EFHouse from './icons/EFHouse';
import EFVans from './icons/EFVans';
import EFYacht from './icons/EFYacht';
import EFOther from './icons/EFOther';
import EFGrid from './icons/EFGrid';
import EFBattery from './icons/EFBattery';
import EFSolar from './icons/EFSolar';
import EFConsumption from './icons/EFConsumption';
import EFEarnings from './icons/EFEarnings';
import EFEnergy from './icons/EFEnergy';
import EFOffGrid from './icons/EFOffGrid';
import { createPortal } from 'react-dom';
import Modal1 from './Modal1';
import Modal2 from './Modal2';
import gtm from '@/utils/gtm';
import getLocal from '@/app/utils/getLocal';
import { useRouter } from 'next/router';

type BoxItemType = {
    icon: JSX.Element;
    text: string;
};

type ImgItemType = {
    img: string;
    title?: string;
    text: string;
};

const C: React.FC = () => {
    const { t } = useLang('Oasis');
    const { locale = 'us' } = useRouter();
    const [enter, setEnter] = useState<number>(4);
    const [video1, setVideo1] = useState<string[]>(['', '']);
    const [video2, setVideo2] = useState<string[][]>([
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
        ['', ''],
    ]);

    const [video3, setVideo3] = useState<string[]>(['', '', '']);
    const [active2Item, setActive2Item] = useState<number>(0);
    const [isOpen, setIsOpen] = useState<number>(0);

    const [box2BtnEnter, setBox2BtnEnter] = useState<boolean>(false);
    const [box4BtnEnter, setBox4BtnEnter] = useState<boolean>(false);
    const { pathname } = getLocal();

    // const video2Arr: string[][] = [
    //     ['https://websiteoss.ecoflow.com/upload/video/1735782555660/C_2A.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784061083/C_2A_M.mp4'],
    //     ['https://websiteoss.ecoflow.com/upload/video/1735782556174/C_2B.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060891/C_2B_M.mp4'],
    //     ['https://websiteoss.ecoflow.com/upload/video/1735782555991/C_2C.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060402/C_2C_M.mp4'],
    //     ['https://websiteoss.ecoflow.com/upload/video/1735782555810/C_2D.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060561/C_2D_M.mp4'],
    //     ['https://websiteoss.ecoflow.com/upload/video/1735782555810/C_2D.mp4', 'https://websiteoss.ecoflow.com/upload/video/1735784060561/C_2D_M.mp4'],
    // ];
    const video2Arr: {
        [key: string]: any;
    } = {
        eu: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266272626/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359637/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174189/monitor-home.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337530/phone_monitor-home_EU-%E6%AC%A7%E5%85%83.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266296705/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-RV.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359406/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174518/monitor_EU-RV.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337311/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266470996/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358684/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174116/monitor_EU-boat.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337200/phone_monitor_EU-boat.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744266494354/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359120/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341217664/monitor_EU-off%20grid.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341338025/phone_monitor_EU-off%20grid.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266536524/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358901/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174583/monitor_EU-other%20device.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337790/phone_monitor_EU-other%20device.jpg',
            ],
        ],
        nl: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266272626/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359637/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174189/monitor-home.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337530/phone_monitor-home_EU-%E6%AC%A7%E5%85%83.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266296705/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-RV.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359406/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174518/monitor_EU-RV.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337311/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266470996/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358684/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174116/monitor_EU-boat.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337200/phone_monitor_EU-boat.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744266494354/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359120/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341217664/monitor_EU-off%20grid.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341338025/phone_monitor_EU-off%20grid.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266536524/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358901/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174583/monitor_EU-other%20device.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337790/phone_monitor_EU-other%20device.jpg',
            ],
        ],
        uk: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744267668345/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E8%8B%B1%E9%95%91.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267818877/%E5%BC%80%E5%8F%91_phone_monitor_home_UK-%E8%8B%B1%E9%95%91.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341703549/monitor-home_EU-%E8%8B%B1%E9%95%91.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342079940/phone_monitor-home_EU-%E8%8B%B1%E9%95%91.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744267668145/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-RV.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267819467/%E5%BC%80%E5%8F%91_phone_monitor_RV_UK.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341703764/monitor_EU-RV.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342079480/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744267667736/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267820012/%E5%BC%80%E5%8F%91_phone_monitor_Uk-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341703079/monitor_EU-boat.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342079001/phone_monitor_EU-boat.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744267667620/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267819608/%E5%BC%80%E5%8F%91_phone_monitor_UK-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341703341/monitor_EU-off%20grid.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342079241/phone_monitor_EU-off%20grid.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744267667923/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267819084/%E5%BC%80%E5%8F%91_phone_monitor_UK-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341703199/monitor_EU-other%20device.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342079718/phone_monitor_EU-other%20device.jpg',
            ],
        ],
        fr: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268074695/monitor-home_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268157624/phone_monitor-home_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342236204/monitor-home_EU0.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342315886/phone_monitor-home_EU0.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268074069/monitor-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268157037/phone_monitor-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342235632/monitor-RV_EU0.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342316286/phone_monitor-RV_EU%2020.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268073882/monitor-boat_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268156881/phone_monitor-boat_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342236021/monitor-boat_EU0.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342315771/phone_monitor-boat_EU0.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744268074481/monitor-off%20grid_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268157453/phone_monitor-off%20grid_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342235826/monitor-off%20grid_EU0.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342316526/phone_monitor-off%20grid_EU0.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268074383/monitor-other%20device_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268157225/phone_monitor-other%20device_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342235481/monitor-other%20device_EU0.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342316085/phone_monitor-other%20device_EU0.jpg',
            ],
        ],
        de: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268317250/monitor-home_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268420136/phone_monitor-home_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342387649/monitor-home_EU.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342466284/phone_monitor-home_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268316550/monitor-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268419430/phone_monitor-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342388196/monitor-RV_EU.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342465804/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268316451/monitor-boat_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268419249/phone_monitor-boat_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342387575/monitor-boat_EU.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342465692/phone_monitor-boat_EU.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744268316939/monitor-off%20grid_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268419934/phone_monitor-off%20grid_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342387801/monitor-off%20grid_EU.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342466081/phone_monitor-off%20grid_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744268316770/monitor-other%20device_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744268419688/phone_monitor-other%20device_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744342388063/monitor-other%20device_EU.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744342466440/phone_monitor-other%20device_EU.jpg',
            ],
        ],
        it: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266272626/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359637/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174189/monitor-home.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337530/phone_monitor-home_EU-%E6%AC%A7%E5%85%83.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266296705/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-RV.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359406/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174518/monitor_EU-RV.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337311/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266470996/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358684/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174116/monitor_EU-boat.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337200/phone_monitor_EU-boat.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744266494354/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359120/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341217664/monitor_EU-off%20grid.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341338025/phone_monitor_EU-off%20grid.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266536524/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358901/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174583/monitor_EU-other%20device.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337790/phone_monitor_EU-other%20device.jpg',
            ],
        ],
        es: [
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266272626/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359637/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-home_EU-%E6%AC%A7%E5%85%83.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174189/monitor-home.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337530/phone_monitor-home_EU-%E6%AC%A7%E5%85%83.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266296705/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-RV.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359406/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF-RV_EU.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174518/monitor_EU-RV.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337311/phone_monitor-RV_EU.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266470996/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358684/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-boat.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174116/monitor_EU-boat.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337200/phone_monitor_EU-boat.jpg',
            ],

            [
                'https://websiteoss.ecoflow.com/upload/video/1744266494354/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267359120/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-off%20grid.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341217664/monitor_EU-off%20grid.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341338025/phone_monitor_EU-off%20grid.jpg',
            ],
            [
                'https://websiteoss.ecoflow.com/upload/video/1744266536524/%E5%BC%80%E5%8F%91-monitor-4%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1744267358901/%E5%BC%80%E5%8F%91_phone_monitor_%E5%9B%9B%E4%B8%AA%E5%9C%BA%E6%99%AF_EU-other%20device.mp4',
                'https://websiteoss.ecoflow.com/upload/image/1744341174583/monitor_EU-other%20device.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1744341337790/phone_monitor_EU-other%20device.jpg',
            ],
        ],
    };

    const box2Items: BoxItemType[] = [
        {
            icon: <EFHouse />,
            text: t('C_box2_text1'),
        },
        {
            icon: <EFVans />,
            text: t('C_box2_text2'),
        },
        {
            icon: <EFYacht />,
            text: t('C_box2_text3'),
        },
        {
            icon: <EFOffGrid />,
            text: t('C_box2_text4'),
        },
        {
            icon: <EFOther />,
            text: t('C_box2_text5'),
        },
    ];

    const box3Items: BoxItemType[] = [
        {
            icon: <EFGrid />,
            text: t('C_box3_text1'),
        },
        {
            icon: <EFBattery />,
            text: t('C_box3_text2'),
        },
        {
            icon: <EFSolar />,
            text: t('C_box3_text3'),
        },
        {
            icon: <EFConsumption />,
            text: t('C_box3_text4'),
        },
        {
            icon: <EFEarnings />,
            text: t('C_box3_text5'),
        },
        {
            icon: <EFEnergy />,
            text: t('C_box3_text6'),
        },
    ];
    // 图片素材
    const box4img: {
        [key: string]: any;
    } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/image/1744623188510/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188637/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188900/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189331/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189071/5.png',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/image/1744623188510/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188637/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188900/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189331/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189071/5.png',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/image/1744623324211/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623323495/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623324014/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623323870/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623323631/5.png',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/image/1744623508091/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623508735/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623508970/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623508478/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623508230/5.png',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/image/1744623622673/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623623615/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623623357/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623622812/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623623021/5.png',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/image/1744623188510/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188637/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188900/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189331/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189071/5.png',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/image/1744623188510/1.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188637/2.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623188900/3.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189331/4.png',
            'https://websiteoss.ecoflow.com/upload/image/1744623189071/5.png',
        ],
    };
    const box4Items: ImgItemType[] = [
        {
            img: box4img[locale][0],
            text: t('C_box4_text1'),
        },
        {
            img: box4img[locale][1],
            text: t('C_box4_text2'),
        },
        {
            img: box4img[locale][2],
            text: t('C_box4_text3'),
        },
        {
            img: box4img[locale][3],
            text: t('C_box4_text4'),
        },
        {
            img: box4img[locale][4],
            text: t('C_box4_text5'),
        },
    ];

    const handleOpenModal = (type: 1 | 2) => {
        setIsOpen(type);
    };

    const handleVideoPlay = (cls: string) => {
        const IS_PC = window?.innerWidth > 1024;
        const video: HTMLVideoElement | null = document.querySelector(`.page-oasis-C .${cls} .ef-video-item-${IS_PC ? 'pc' : 'h5'}`);
        if (video) {
            video.currentTime = 0;
            video.play();
        }
    };
    const Video1Items: {
        [key: string]: any;
    } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616429/EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744456995779/EU-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877704662/EU-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744456995191/EU-M.jpg',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616429/EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744456995779/EU-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877704662/EU-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744456995191/EU-M.jpg',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1744617615172/UX.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744457201289/UK-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877729252/UK-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744457201973/UK-M.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616020/DE.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744457250987/DE-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877761519/DE-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744457250329/DE-M.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616964/FR.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744457292740/FR-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877807674/FR-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744457292159/DE2.jpg',
        ],
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616429/EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744456995779/EU-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877704662/EU-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744456995191/EU-M.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1744617616429/EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744456995779/EU-M.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744877704662/EU-PC.jpg',
            'https://websiteoss.ecoflow.com/upload/image/1744456995191/EU-M.jpg',
        ],
    };
    useEffect(() => {
        // 其实也可以写成AniContainer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && entry.target.classList[0] === 'Charts' && video1?.some((v: string) => !v)) {
                    // 进入B模块时加载第一个视频
                    setVideo1([Video1Items[locale][0], Video1Items[locale][1]]);
                }
            });
        });

        const sectionB: HTMLDivElement | null = document.querySelector('.Charts');
        if (sectionB) {
            observer.observe(sectionB);
        }
    }, []);

    const box3Video: {
        [key: string]: any;
    } = {
        eu: [
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630120496/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.jpg',
        ],
        nl: [
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630120496/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.jpg',
        ],
        uk: [
            'https://websiteoss.ecoflow.com/upload/video/1744630119763/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-uk.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630119763/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-uk.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630119506/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-UK.jpg',
        ],
        fr: [
            'https://websiteoss.ecoflow.com/upload/video/1744630119252/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-fr.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630119252/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-fr.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630120028/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-FR.jpg',
        ],
        de: [
            'https://websiteoss.ecoflow.com/upload/video/1744630120291/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-de.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630120291/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-de.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630119082/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-DE.jpg',
        ],
        // 以下暂未提供素材，先用eu的
        it: [
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630120496/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.jpg',
        ],
        es: [
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/video/1744630120728/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.mp4',
            'https://websiteoss.ecoflow.com/upload/image/1744630120496/%E5%BC%80%E5%8F%91-monitor-dashboard_%E5%8D%95%E6%89%8B%E6%9C%BA-EU.jpg',
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const container = '.page-oasis-C';
            const IS_PC = window?.innerWidth > 1024;
            // 进场enter + 加载资源
            const enter1 = AniContainer.create({
                triggerElement: '.page-oasis-C .box1',
                triggerHook: 1,
                offset: '0%',
                duration: '150%',
                onEnter: () => {
                    setEnter(1);
                    setVideo2(video2Arr[locale]);
                },
            });
            const enter2 = AniContainer.create({
                triggerElement: '.page-oasis-C .box2',
                triggerHook: 1,
                offset: '150%',
                duration: '100%',
                onEnter: () => {
                    setEnter(2);
                    setVideo3(box3Video[locale]);
                },
            });

            // 进入开始播放视频
            const video1 = document.querySelector('.page-oasis-C .box1 .video-box') as HTMLDivElement;
            const playVideo1 = AniContainer.create({
                triggerElement: '.page-oasis-C .box1 .video-box',
                triggerHook: 1,
                offset: video1?.offsetHeight / 2,
                duration: IS_PC ? '100%' : '50%',
                onEnter: () => handleVideoPlay('box1'),
            });
            const video2 = document.querySelector('.page-oasis-C .box2 .video-box') as HTMLDivElement;
            const playVideo2 = AniContainer.create({
                triggerElement: '.page-oasis-C .box2 .video-box',
                triggerHook: 1,
                offset: IS_PC ? '150%' : video2?.offsetHeight / 2,
                duration: IS_PC ? '100%' : '50%',
                onEnter: () => handleVideoPlay('box2'),
            });
            const video3 = document.querySelector('.page-oasis-C .box3 .video-box') as HTMLDivElement;
            const playVideo3 = AniContainer.create({
                triggerElement: '.page-oasis-C .box3 .video-box',
                triggerHook: 1,
                offset: IS_PC ? '250%' : video3?.offsetHeight / 2,
                duration: '100%',
                onEnter: () => handleVideoPlay('box3'),
            });

            if (IS_PC) {
                // => 仅PC端
                // 滚动条控制动画
                const scroll = AniContainer.create({
                    asyncFromTo: [
                        ['.page-oasis-C .box1 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box1 视频秒现
                        ['.page-oasis-C .box1 .info .inner', { opacity: 0 }, { opacity: 1 }, 0.2], // box1 文案渐显
                        ['.page-oasis-C .box1 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box1 文案维持
                        ['.page-oasis-C .box1 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box1 文案渐隐
                        ['.page-oasis-C .box1 .video-box', { opacity: 1 }, { opacity: 0 }, 0.001], // box1 视频秒隐

                        ['.page-oasis-C .box2 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box2 视频秒现
                        ['.page-oasis-C .box2 .info .inner', { opacity: 0, y: 120 }, { opacity: 1, y: 0 }, 0.2], // box2 文案渐显
                        ['.page-oasis-C .box2 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box2 文案维持
                        ['.page-oasis-C .box2 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box2 文案渐隐
                        ['.page-oasis-C .box2 .video-box', { opacity: 1 }, { opacity: 0 }, 0.01], // box2 视频秒隐

                        ['.page-oasis-C .box3 .video-box', { opacity: 0 }, { opacity: 1 }, 0.001], // box3 视频秒现
                        ['.page-oasis-C .box3 .info .inner', { opacity: 0, y: 120 }, { opacity: 1, y: 0 }, 0.2], // box3 文案渐显
                        ['.page-oasis-C .box3 .info .inner', { opacity: 1 }, { opacity: 1 }, 0.6], // box3 文案维持
                        ['.page-oasis-C .box3 .info .inner', { opacity: 1, y: 0 }, { opacity: 0, y: -120 }, 0.2], // box3 文案渐隐
                        ['.page-oasis-C .box3 .video-box', { opacity: 1 }, { opacity: 0 }, 0.001], // box3 视频隐

                        ['.page-oasis-C .box4 .items', { opacity: 0 }, { opacity: 1 }, 0.001], // box4 图片秒现
                        // ['.page-oasis-C .box4 .items .item-2 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-2 上移
                        // ['.page-oasis-C .box4 .items .item-4 .item-inner', { y: 0 }, { y: -60 }, 0.25], // box4 item-4 上移
                        ['.page-oasis-C .box4 .info', { opacity: 1 }, { opacity: 1 }, 1], // box4 维持
                    ],
                    asyncTimeLine: [
                        0, 0.5, 0.7, 1.3, 1.499,
                        // 0, 0.5, 0.65, 0.85, 0.9995,
                        // 1 - 2
                        1.499, 1.5, 1.7, 2.3, 2.499,
                        // 2- 3
                        2.499, 2.5, 2.7, 3.3, 3.499,
                        // 3 - 4
                        // 3.499, 3.75, 3.75, 4.5,
                        3.499, 4.5,
                    ],
                    triggerElement: container,
                    triggerHook: 1,
                    offset: 0,
                    duration: '550%',
                });
                // css 动画
                // box2 按钮 等文案全部显示后出现
                const box2BtnEnter = AniContainer.create({
                    triggerElement: container,
                    triggerHook: 1,
                    offset: '170%',
                    duration: '60%',
                    onEnter: () => setBox2BtnEnter(true),
                    onLeave: () => setBox2BtnEnter(false),
                });
                // enter3和enter4
                const enter3 = AniContainer.create({
                    triggerElement: '.page-oasis-C .box3',
                    triggerHook: 1,
                    offset: '250%',
                    duration: '100%',
                    onEnter: () => {
                        setEnter(3);
                        const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-C .box3 .ani-img');
                        if (aniImg) {
                            const styleObj = {
                                '1920': {
                                    bottom: '0%',
                                    left: '53.2%',
                                },
                                '1366': {
                                    bottom: '0%',
                                    left: '53%',
                                },
                            };
                            const screenWidth = window?.innerWidth > 1440 ? '1920' : '1366';
                            const curStyle = styleObj[screenWidth];
                            aniImg.style.bottom = curStyle.bottom;
                            aniImg.style.left = curStyle.left;
                            aniImg.style.opacity = 0;
                        }
                    },
                });
                // box3+box4 小图片位移+缩放+box4图片展开
                const enter4 = AniContainer.create({
                    triggerElement: '.page-oasis-C .box4',
                    triggerHook: 1,
                    offset: '350%',
                    duration: '500%',
                    onEnter: () => {
                        setEnter(4);
                        const timer = setInterval(() => {
                            const img3: HTMLLIElement | null = document.querySelector('.page-oasis-C .box4 .item-3');
                            const aniImg: HTMLDivElement | null = document.querySelector('.page-oasis-C .box3 .ani-img');
                            if (img3 && aniImg) {
                                const { offsetTop, offsetLeft } = img3;
                                aniImg.style.top = `${offsetTop}px`;
                                aniImg.style.left = `${offsetLeft}px`;
                                aniImg.style.opacity = 1;
                                clearInterval(timer);
                            }
                        }, 100);
                    },
                });
                // box4 按钮 等文案全部显示后出现
                const box4BtnEnter = AniContainer.create({
                    triggerElement: container,
                    triggerHook: 1,
                    offset: '350%',
                    duration: '90%',
                    onEnter: () => setBox4BtnEnter(true),
                    onLeave: () => setBox4BtnEnter(false),
                });
                return () => {
                    const sceneArr = [scroll, box2BtnEnter, enter3, enter4, box4BtnEnter];
                    sceneArr.forEach((scene) => scene.destroy());
                };
            }
            if (!IS_PC) {
                const winH = window.innerHeight;
                const winW = window.innerWidth;
                const box4Lists: HTMLUListElement | null = document.querySelector('.page-oasis-C .box4 .items');
                const box4Item: HTMLUListElement | null = document.querySelector('.page-oasis-C .box4 .items .item');
                const box4ItemsScroll = AniContainer.create({
                    asyncFromTo: [
                        [
                            box4Lists,
                            { x: (winW - Number(box4Item?.offsetWidth)) / 2 },
                            { x: winW / 2 - Number(box4Lists?.offsetWidth) + Number(box4Item?.offsetWidth) / 2 },
                            8,
                        ],

                        ['.page-oasis-C .box4 .items .item-1 .item-text', { opacity: 1 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-1 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-1 .ef-img', { scale: 1.4 }, { scale: 1 }, 1],

                        ['.page-oasis-C .box4 .items .item-2 .ef-img', { scale: 1 }, { scale: 1.4 }, 1.75],
                        ['.page-oasis-C .box4 .items .item-2 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-2 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-2 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-C .box4 .items .item-3 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-C .box4 .items .item-3 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-3 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-3 .ef-img', { scale: 1.4 }, { scale: 1 }, 2],

                        ['.page-oasis-C .box4 .items .item-4 .ef-img', { scale: 1 }, { scale: 1.4 }, 2],
                        ['.page-oasis-C .box4 .items .item-4 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-4 .item-text', { opacity: 1 }, { opacity: 0 }, 0.25],
                        ['.page-oasis-C .box4 .items .item-4 .ef-img', { scale: 1.4 }, { scale: 1 }, 1.75],

                        ['.page-oasis-C .box4 .items .item-5 .ef-img', { scale: 1 }, { scale: 1.4 }, 1],
                        ['.page-oasis-C .box4 .items .item-5 .item-text', { opacity: 0 }, { opacity: 1 }, 0.25],
                    ],
                    asyncTimeLine: [
                        // 8份=> 1 : 2 : 2 : 2 : 1
                        0,
                        // 1份
                        0, 0.5, 0,
                        // 2份
                        0.5, 1.25, 2.5, 2.25,
                        // 2份
                        2, 3.5, 4.5, 4,
                        // 2份
                        4, 4.5, 6, 5.75,
                        // 1份
                        6.5, 6.75,
                    ],
                    triggerElement: '.page-oasis-C .box4 .items-box',
                    triggerHook: 1,
                    duration: winH,
                    offset: '100%',
                });
                // box2 按钮 等文案全部显示后出现
                const box2BtnEnter = AniContainer.create({
                    triggerElement: '.page-oasis-C .box2 .btn',
                    triggerHook: 1,
                    offset: 120,
                    duration: '100%',
                    onEnter: () => setBox2BtnEnter(true),
                    onLeave: () => setBox2BtnEnter(false),
                });
                const box4BtnEnter = AniContainer.create({
                    triggerElement: '.page-oasis-C .box4 .btn',
                    triggerHook: 1,
                    offset: 120,
                    duration: '300%',
                    onEnter: () => setBox4BtnEnter(true),
                    onLeave: () => setBox4BtnEnter(false),
                });
                return () => {
                    box4ItemsScroll.destroy();
                    box2BtnEnter.destroy();
                    box4BtnEnter.destroy();
                };
            }
            return () => {
                const secneArr = [enter1, enter2, playVideo1, playVideo2, playVideo3];
                secneArr.forEach((scene) => scene.destroy());
            };
        }
    }, []);

    useEffect(() => {
        handleVideoPlay(`box2 .v${active2Item + 1}`);
    }, [active2Item]);

    return (
        <div className={`page-oasis-C ${css.section}`} id="page-oasis-C">
            <div className="sticky">
                <div className={`box box1 ${enter === 1 ? 'enter' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <div className="label">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M17 2H7C6.17157 2 5.5 2.67157 5.5 3.5V20.5C5.5 21.3284 6.17157 22 7 22H17C17.8284 22 18.5 21.3284 18.5 20.5V3.5C18.5 2.67157 17.8284 2 17 2Z"
                                        stroke="#4071FF"
                                        strokeWidth="2"
                                    />
                                    <path d="M11 5H13" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10 19H14" stroke="#4071FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <span className="label-text">{t('C_box1_label')}</span>
                            </div>
                            <p className="title">{t(`C_box1_title`)}</p>
                            <p className="desc">
                                {t.rich(`C_box1_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                    <div className="video-box">
                        {(video1[0] || video1[1]) && (
                            <EfVideo pc={video1[0]} h5={video1[1]} poster={Video1Items[locale][2]} posterH5={Video1Items[locale][3]} preload="none" />
                        )}
                    </div>
                </div>
                <div className={`box box2 ${enter === 2 ? 'enter' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box2_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box2_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                    sup: (tx: string) => <sup>{tx}</sup>,
                                })}
                            </p>
                            <ul className="items">
                                {box2Items.map((item: BoxItemType, k) => (
                                    <li
                                        className={`item${active2Item === k ? ' active' : ''} item-${k + 1}`}
                                        key={k}
                                        onClick={() => {
                                            console.log('kkkkk', k);
                                            setActive2Item(k);
                                            gtm.push({
                                                event: 'uaEvent',
                                                event_name: 'tab_click',
                                                button_name: item.text,
                                                list_name: t(`C_box2_title`),
                                            });
                                        }}
                                    >
                                        {k === 4 && <p className="item-text-title">{t('C_box2_text_title')}</p>}
                                        {item.icon}
                                        <p className="item-text">{item.text}</p>
                                    </li>
                                ))}
                            </ul>
                            {/* <p className="tip">{t('C_box2_tip')}</p> */}
                        </div>
                    </div>
                    <div className="video-box">
                        {(video2?.[0]?.[0] || video2?.[0]?.[1]) && (
                            <EfVideo
                                className={`video v1 ${active2Item === 0 ? 'active' : ''}`}
                                pc={video2[0][0]}
                                h5={video2[0][1]}
                                poster={video2[0][2]}
                                posterH5={video2[0][3]}
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2?.[1]?.[0] || video2?.[1]?.[1]) && (
                            <EfVideo
                                className={`video v2 ${active2Item === 1 ? 'active' : ''}`}
                                pc={video2[1][0]}
                                h5={video2[1][1]}
                                poster={video2[1][2]}
                                posterH5={video2[1][3]}
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2?.[2][0] || video2?.[2][1]) && (
                            <EfVideo
                                className={`video v3 ${active2Item === 2 ? 'active' : ''}`}
                                pc={video2[2][0]}
                                h5={video2[2][1]}
                                poster={video2[2][2]}
                                posterH5={video2[2][3]}
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2?.[3]?.[0] || video2?.[3]?.[1]) && (
                            <EfVideo
                                className={`video v4 ${active2Item === 3 ? 'active' : ''}`}
                                pc={video2[3][0]}
                                h5={video2[3][1]}
                                poster={video2[3][2]}
                                posterH5={video2[3][3]}
                                loop={true}
                                preload="none"
                            />
                        )}
                        {(video2?.[4]?.[0] || video2?.[4]?.[1]) && (
                            <EfVideo
                                className={`video v5 ${active2Item === 4 ? 'active' : ''}`}
                                pc={video2[4][0]}
                                h5={video2[4][1]}
                                poster={video2[4][2]}
                                posterH5={video2[4][3]}
                                loop={true}
                                preload="none"
                            />
                        )}
                    </div>
                    <button
                        className={`btn ${box2BtnEnter ? 'enter' : ''}`}
                        onClick={() => {
                            handleOpenModal(1);
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_button',
                                page_name: pathname,
                                function: t(`C_box2_btn`),
                                button_name: t(`C_box2_btn`),
                                list_name: t(`C_box2_title`),
                            });
                        }}
                    >
                        <span className="btn-text">{t(`C_box2_btn`)}</span>
                        <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                    </button>
                </div>
                <div className={`box box3 ${enter === 3 ? 'enter' : ''} ${enter === 4 ? 'enterBox4' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box3_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box3_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                            <ul className="items">
                                {box3Items.map((item: BoxItemType, k) => (
                                    <li className="item" key={k}>
                                        {item.icon}
                                        <p className="item-text">{item.text}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className="video-box">{(video3[0] || video3[1]) && <EfVideo pc={video3[0]} h5={video3[1]} poster={video3[2]} preload="none" />}</div>
                    <div className="ani-img">
                        <div className="ani-box ani-1">
                            <EfImg pc={video3[2]} />
                        </div>
                        <div className="ani-box ani-2">
                            <EfImg pc={box4Items[2].img} />
                        </div>
                        <div className="ani-box ani-3">
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1735192448952/D_ani_small.png" />
                        </div>
                    </div>
                    <button
                        className={`btn ${box4BtnEnter ? 'enter' : ''}`}
                        onClick={() => {
                            handleOpenModal(2);
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'activity_button',
                                page_name: pathname,
                                function: t(`C_box4_btn`),
                                button_name: t('C_box4_btn'),
                                list_name: t('C_box4_title'),
                            });
                        }}
                    >
                        <span className="btn-text">{t('C_box4_btn')}</span>
                        <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                    </button>
                </div>
                <div className={`box box4 ${enter === 4 ? 'enter' : ''} ${enter === 4 ? 'enterBox4' : ''}`}>
                    <div className="info">
                        <div className="inner">
                            <p className="title s">{t(`C_box4_title`)}</p>
                            <p className="desc s">
                                {t.rich(`C_box4_desc`, {
                                    w: (tx: string) => <span className="w">{tx}</span>,
                                })}
                            </p>
                        </div>
                        <div className="items-sticky">
                            <div className="items-box">
                                <ul className="items">
                                    {box4Items.map((item, k) => (
                                        <li className={`item item-${k + 1}`} key={k}>
                                            <div className={`item-inner item-inner-${k}`}>
                                                <div className="item-img">
                                                    <EfImg pc={item.img} />
                                                </div>
                                                <p className="item-text">{item.text}</p>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <button className={`btn ${box4BtnEnter ? 'enter' : ''}`} onClick={() => handleOpenModal(2)}>
                                <span className="btn-text">{t('C_box4_btn')}</span>
                                <EfImg className="btn-plus" pc="https://websiteoss.ecoflow.com/upload/image/1735629290398/add.svg" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen === 1 && createPortal(<Modal1 type={isOpen} callback={() => setIsOpen(0)} />, document.body)}
            {isOpen === 2 && createPortal(<Modal2 type={isOpen} callback={() => setIsOpen(0)} />, document.body)}
        </div>
    );
};

export default C;
